import jump from './jump';

const MINIMAL_TIME = 200;
const MAXIMAL__TIME = 1500;
const DEFAULT_OFFSET = {
    up: -170,
    down: -70
};

function getDuration(distance) {
    return Math.min(Math.max(Math.abs(distance), MINIMAL_TIME), MAXIMAL__TIME);
}

function emitEvent(data) {
    window.emitter.emit('jumped', data);
}

const href = location.hash;
if (href) {
    const target = document.querySelector(href);
    if (target) {
        // Scroll to the correct place of a has is given
        window.addEventListener('load', () => {
            setTimeout(() => {
                jump(target, {
                    offset: DEFAULT_OFFSET,
                    duration: 0,
                    callback: () => {
                        emitEvent({ target, href });
                    }
                });
            }, 100);
        });
    }
}

[...document.querySelectorAll('a[href*="#"][data-jump]')].forEach(trigger => {
    const href = trigger.getAttribute('href');
    const target = document.querySelector(href);

    let closeAccordion = () => {};
    if (trigger.dataset.closeAccordion != null) {
        const ACCORDION = trigger.closest('.-js-accordion');
        const TRIGGER = ACCORDION ? ACCORDION.querySelector('.-js-accordion__trigger') : null;
        if (TRIGGER) {
            closeAccordion = () => {
                TRIGGER.click();
            };
        }
    }

    if (target) {
        const offset = {
            up: parseInt(target.dataset.jumpOffsetUp) || DEFAULT_OFFSET.up,
            down: parseInt(target.dataset.jumpOffsetDown) || DEFAULT_OFFSET.down
        };
        trigger.addEventListener('click', event => {
            event.preventDefault();
            closeAccordion();
            jump(target, {
                offset,
                duration: getDuration,
                callback: () => {
                    emitEvent({ trigger, target, href });
                }
            });
        });
    }
});

window.jump = jump;
